import { createSlice } from "@reduxjs/toolkit";

const initialJobState = {
  vacancyRequisitions: [],
  page: null,
  limit: null,
  watchList: [],
  totalPages: null,
  selectedVacancyRequisition: null,
  listLoading: false,
  totalResults: null,
  actionLoading: false,
};

export const vacancyRequisitionManagementSlice = createSlice({
  name: "vacancyRequisitionManagementSlice",
  initialState: initialJobState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    getAllVacancyRequisition: (state, action) => {
      const { page, limit, totalPages, totalResults, results } = action?.payload?.data?.data;
      state.vacancyRequisitions = results;
      state.limit = limit;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.page = page;
      state.listLoading = false;
    },

    setSelectedVacancyRequisition: (state, action) => {
      const vacancyRequisition = action.payload;
      state.selectedVacancyRequisition = vacancyRequisition;
      state.actionLoading = false;

      if (vacancyRequisition?.jobAgainstVacancyRequisiton && Object?.keys(vacancyRequisition?.jobAgainstVacancyRequisiton)?.length > 0) {
        state.page = vacancyRequisition?.page;
        state.limit = vacancyRequisition?.limit;
        state.totalPages = vacancyRequisition?.totalPages;
        state.totalResults = vacancyRequisition?.totalResults;
      }
    },

    cleanUpSelectedVacancyRequisition: (state, action) => {
      state.selectedVacancyRequisition = null;
      state.page = null;
      state.limit = null;
      state.totalPages = null;
      state.totalResults = null;
    },
  },
});
